// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__9lvnK","main":"MainLayout_main__o4Naz"};